/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, June 15th 2022, 9:06:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Typography } from "ui-widgets";
import { COLORSCHEME } from "theme/styles";
import { NODE_TYPES } from "lib/schemas";
import Tooltip from "@mui/material/Tooltip";
import { BPMNTaskTypeIcon } from "service-builder/components/workflow-builder/TaskTemplateIcons";

interface TaskTypeSelectorButtonProps {
  bpmnNodeType: keyof typeof NODE_TYPES;
  customIcon?: React.ReactNode;
  customTitle?: string;
  tooltipText: string;
  onClick: any;
}

export const TaskTypeSelectorButton = ({
  bpmnNodeType,
  tooltipText,
  onClick,
  customIcon,
  customTitle,
}: TaskTypeSelectorButtonProps) => (
  <Tooltip title={<Typography variant="subtitle1">{tooltipText}</Typography>} placement="top" arrow>
    <div
      className="os-bpmn-task-type-selector-icon-button"
      style={{ textAlign: "center", cursor: "pointer" }}
      onClick={onClick}
    >
      {customIcon ? customIcon : <BPMNTaskTypeIcon taskType={bpmnNodeType} color={COLORSCHEME.primary} fontSize={40} />}
      <p> {customTitle ? customTitle : NODE_TYPES[bpmnNodeType]} </p>
    </div>
  </Tooltip>
);
